import { REFUND_SUCCESS_ADD, REFUND_SUCCESS_EDIT, BANK_LIST_RESULT, LIST_USER_REFUNDS, ITEM_SELECTED_FOR_EDIT_REFUND } from '../action/actionTypes'

const initialState = {
    ResultOfAddRefund: null,
    ResultOfEditRefund: null,
    BanklIst: null,
    refundList: null,
    selecteValue: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REFUND_SUCCESS_ADD:
            return {
                ...state,
                ResultOfAddRefund: action.ResultOfAddRefund
            }
        case REFUND_SUCCESS_EDIT:
            return {
                ...state,
                ResultOfEditRefund: action.ResultOfEditRefund
            }
        case BANK_LIST_RESULT:
            return {
                ...state,
                BanklIst: action.BanklIst
            }
        case LIST_USER_REFUNDS:
            return {
                ...state,
                refundList: action.refundList
            }
        case ITEM_SELECTED_FOR_EDIT_REFUND:
            return {
                ...state,
                selecteValue: action.selecteValue
            }
        default:
            return state;
    }
};

export default reducer;